
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M431.8 100.4v19H270v-30h26v-87H70.2v87h26.1v135.8h-26v87H296v-87h-26V196h161.8v21.1H512V100.4h-80.2zM265 281.2H101.2v-25H265v25zm-137.7-56V89.4H239v135.8H127.3zM265 58.3H101.2V33.4H265v25zM431.9 165h-162v-14.5h162V165zm49 21.1h-18v-54.6h18v54.6zM352.6 478.6v-56a35.5 35.5 0 00-27.1-34.6v-50.7H45V388a35.5 35.5 0 00-27.2 34.5v56H0v31.2h370.4v-31.1h-17.8zM76 368.4h218.4V387H76v-18.6zm245.5 110.2H49v-56c0-2.5 2-4.5 4.4-4.5h263.8c2.4 0 4.4 2 4.4 4.4v56z","fill":"currentColor"}})])
          )
        }
      }
    